import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadNewsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadNewsQuery = (
  { __typename?: 'Query' }
  & { multinews: Array<(
    { __typename?: 'News' }
    & Pick<Types.News, '_id' | '_deleted' | 'inactive' | 'deletionPeriod' | 'deletionRule' | 'title' | 'created' | 'modified' | 'description' | 'files' | 'body'>
    & { provingGround: Array<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type CreateNewsMutationVariables = {
  input: Types.NewsCreateInput
};


export type CreateNewsMutation = (
  { __typename?: 'Mutation' }
  & { createNews: (
    { __typename?: 'News' }
    & Pick<Types.News, '_id'>
  ) }
);

export type UpdateNewsMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.NewsUpdateInput
};


export type UpdateNewsMutation = (
  { __typename?: 'Mutation' }
  & { updateNews: (
    { __typename?: 'News' }
    & Pick<Types.News, '_id'>
  ) }
);

export type DeleteNewsMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteNewsMutation = (
  { __typename?: 'Mutation' }
  & { deleteNews: Array<(
    { __typename?: 'News' }
    & Pick<Types.News, '_id'>
  )> }
);

export const ReadNewsDocument = gql`
    query ReadNews($search: String) {
  multinews(filter: {title: {REGEX: $search, OPTIONS: "i"}}, sort: {modified: ASC}) {
    _id
    _deleted
    inactive
    deletionPeriod
    deletionRule
    title
    created
    modified
    description
    provingGround {
      _id
      title
    }
    files
    body
  }
}
    `;

    export function useReadNewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadNewsQuery, ReadNewsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadNewsQuery, ReadNewsQueryVariables>(ReadNewsDocument, baseOptions);
    };
      export function useReadNewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadNewsQuery, ReadNewsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadNewsQuery, ReadNewsQueryVariables>(ReadNewsDocument, baseOptions);
      };
      
export type ReadNewsQueryHookResult = ReturnType<typeof useReadNewsQuery>;
export type ReadNewsQueryResult = ApolloReactCommon.QueryResult<ReadNewsQuery, ReadNewsQueryVariables>;
export const CreateNewsDocument = gql`
    mutation CreateNews($input: NewsCreateInput!) {
  createNews(input: $input) {
    _id
  }
}
    `;
export type CreateNewsMutationFn = ApolloReactCommon.MutationFunction<CreateNewsMutation, CreateNewsMutationVariables>;

    export function useCreateNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewsMutation, CreateNewsMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateNewsMutation, CreateNewsMutationVariables>(CreateNewsDocument, baseOptions);
    };
export type CreateNewsMutationHookResult = ReturnType<typeof useCreateNewsMutation>;
export type CreateNewsMutationResult = ApolloReactCommon.MutationResult<CreateNewsMutation>;
export type CreateNewsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewsMutation, CreateNewsMutationVariables>;
export const UpdateNewsDocument = gql`
    mutation UpdateNews($id: ID!, $update: NewsUpdateInput!) {
  updateNews(id: $id, input: $update) {
    _id
  }
}
    `;
export type UpdateNewsMutationFn = ApolloReactCommon.MutationFunction<UpdateNewsMutation, UpdateNewsMutationVariables>;

    export function useUpdateNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNewsMutation, UpdateNewsMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateNewsMutation, UpdateNewsMutationVariables>(UpdateNewsDocument, baseOptions);
    };
export type UpdateNewsMutationHookResult = ReturnType<typeof useUpdateNewsMutation>;
export type UpdateNewsMutationResult = ApolloReactCommon.MutationResult<UpdateNewsMutation>;
export type UpdateNewsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNewsMutation, UpdateNewsMutationVariables>;
export const DeleteNewsDocument = gql`
    mutation DeleteNews($ids: [ID!]!) {
  deleteNews(ids: $ids) {
    _id
  }
}
    `;
export type DeleteNewsMutationFn = ApolloReactCommon.MutationFunction<DeleteNewsMutation, DeleteNewsMutationVariables>;

    export function useDeleteNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNewsMutation, DeleteNewsMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteNewsMutation, DeleteNewsMutationVariables>(DeleteNewsDocument, baseOptions);
    };
export type DeleteNewsMutationHookResult = ReturnType<typeof useDeleteNewsMutation>;
export type DeleteNewsMutationResult = ApolloReactCommon.MutationResult<DeleteNewsMutation>;
export type DeleteNewsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNewsMutation, DeleteNewsMutationVariables>;